import type { UserAvatarSize } from './UserAvatar.styles'

// Glyph inset for the AI badge. Smaller than the circle so the mark keeps
// breathing room, matching the optical weight of UserAvatar's initials.
const AI_GLYPH_WIDTH: Record<UserAvatarSize, string> = {
  sm: '14px',
  md: '18px',
  // Keeps the same glyph-to-circle ratio as sm/md at the 48px size.
  lg: '27px',
}

/**
 * Sizes the AI glyph inside its circle. Width only — the mark's viewBox is
 * taller than it is wide, so pinning both axes would squash it.
 */
export const aiGlyphCss = (size: UserAvatarSize) => ({
  '& svg': { width: AI_GLYPH_WIDTH[size], height: 'auto' },
})
